<div class="w-100 overflow-hidden">
  <div class="text-center mb-2" *ngIf="data.showCongratulation">
    <strong>{{ data.name }}</strong> {{ 'Sellers.Products.SuccessfullyAdded' | translate }}
  </div>
  <div class="url-field m-auto" (click)=copyInputMessage(data.url)>
    <div class="d-flex justify-content-center">
      <mat-icon class="text-dark">content_copy</mat-icon> &nbsp; <span class="text-dark">{{data.url}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="share-btns m-auto">
        <app-share [showEmail]="true" [url]="data.url"></app-share>
      </div>
    </div>
  </div>
</div>
